module.exports = __webpack_public_path__ + "static/result-404.861e65d1.png";